<template>
  <el-dialog
      v-if="visible"
      @close="doReset"
      :title="result.id?'编辑结果':'添加结果'"
      :destroy-on-close="true"
      :append-to-body="true"
      :visible.sync="visible"
      :modal-append-to-body="true"
      width="880px">
    <div class="question-save-page">
      <el-form :model="result" label-width="80px" size="small" label-position="right">
        <el-form-item label="维度名称:" prop="title">
          <el-input v-model="result.name"/>
        </el-form-item>
        <el-form-item label="字符值:" prop="title">
          <el-input v-model="result.keyName"/>
        </el-form-item>
        <el-form-item label="分数:" prop="title">
          <el-input v-model="result.score"/>
        </el-form-item>
        <el-form-item label="类型:" prop="title">
          <el-radio-group v-model="result.type">
            <el-radio :label="1">单分</el-radio>
            <el-radio :label="2">区间</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="特点:" prop="title">
          <el-input type="textarea" :autosize="{ minRows: 3}" v-model="result.points"></el-input>
        </el-form-item>
        <el-form-item label="描述:" prop="title">
          <el-input type="textarea" :autosize="{ minRows: 3}" v-model="result.content"></el-input>
        </el-form-item>
        <div class="text-align-center margin-top-20">
          <el-button type="primary" @click="save()" round><i class="fa fa-save"></i> 保存</el-button size="small">
          <el-button @click="doReset()" round><i class="fa fa-close"></i> 关闭</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
  import {addPaperResult, editPaperResult} from '@/api/manage/result'

  export default {
    name: 'paperResultSave',
    props: {
      result:null,
      visible:false
    },
    data() {
      return {}
    },
    methods: {
      doReset() {
        this.$emit('done', false)
      },
      save() {
        if (this.result.id) {
          editPaperResult(this.result).then(res => {
            this.$emit('done', true)
          })
        } else {
          let param = []
          param.push(this.result)
          addPaperResult(param).then(res => {
            this.$emit('done', true)
          })
        }
      }
    }
  }
</script>
